/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_UNITS } from '../../actions.type'
import {
  CREATE_UNIT,
  REMOVE_UNIT,
  SET_UNIT_ALL_REQUEST,
  SET_UNIT_ALL_VALUE,
  UPDATE_UNIT
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  unitAllValue: (state) => state.all.value,
  unitAllRequest: (state) => state.all.request,
  unitAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_UNITS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('unit', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_UNIT_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_UNIT_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_UNIT_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_UNIT_ALL_VALUE, data)
    } catch (e) {
      commit(SET_UNIT_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_UNIT({ commit }, value) {
    commit(CREATE_UNIT, value)
  },

  async SOCKET_UPDATE_UNIT({ commit }, value) {
    commit(UPDATE_UNIT, value)
  },

  async SOCKET_REMOVE_UNIT({ commit }, id) {
    commit(REMOVE_UNIT, id)
  }
}

const mutations = {
  [SET_UNIT_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_UNIT_ALL_VALUE](state, units) {
    state.all.value = units
  },
  [UPDATE_UNIT](state, updatedUnit) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedUnit.id }),
      1,
      updatedUnit
    )
  },
  [CREATE_UNIT](state, createdUnit) {
    state.all.value.push(createdUnit)
  },
  [REMOVE_UNIT](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
